module.exports = __webpack_public_path__ + "img/17779470_175664447153970_4704394038762800289_n.24c8d845.jpg";